exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-block-title[data-v-0a676bb2] {\n  margin: 15px 15px 10px\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a676bb2","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/accounts/CMAccountMembersPage/CMAccountMembersList.vue
// module id = 1525
// module chunks = 2